import React, { createContext, useContext, useMemo } from 'react';

// Create context with an object as the default value
const HostnameContext = createContext({
	hostname: '',
	flags: {
		isPomi: false,
		isFLDean: false,
		isStarr: false,
		isContractCoverage: false,
		isInterplanetary: false,
		isDefault: true,
	},
});

// Custom hook to get just the hostname string
export const useHostname = () => {
	const context = useContext(HostnameContext);
	return context.hostname;
};

// Hook to get the boolean flags
export const useHostnameFlags = () => {
	const context = useContext(HostnameContext);
	return context.flags;
};

export const HostnameProvider = ({ children }) => {
	const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

	const contextValue = useMemo(() => {
		// Calculate all the flags based on the hostname
		const flags = {
			isPomi: hostname.includes('pomi'),
			isFLDean: hostname.includes('fldean'),
			isStarr: hostname.includes('starr'),
			isContractCoverage: hostname.includes('contractcoverage'),
			isInterplanetary: hostname.includes('interplanetary'),
		};

		// Add isDefault flag
		flags.isDefault = !flags.isPomi && !flags.isFLDean &&
                      !flags.isStarr && !flags.isContractCoverage && !flags.isInterplanetary;

		// Return the complete context object
		return {
			hostname,
			flags,
		};
	}, [hostname]);

	return (
		<HostnameContext.Provider value={contextValue}>
			{children}
		</HostnameContext.Provider>
	);
};

export default HostnameProvider;
